<!--
    描述：
    日期：2022/06/24
    作者：张卫华
-->
<template>
  <div class="add-template-form-page">
    <el-form :model="objectForm"
             :rules="objectFormRules"
             ref="objectForm"
             label-width="110px">
      <el-row>
        <el-col :span="24">
          <el-form-item label="模板名称"
                        prop="docTemplateName"
                        :show-message="false">
            <el-input v-model="objectForm.docTemplateName"
                      placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="上传模板">
            <esTemplateUpload ref="uploadTemplate"
                              assortment="content"
                              :needRefresh="false"
                              :mode="mode"
                              :multiple="false"
                              :maxNum="1"
                              :acceptType="acceptType"
                              :docTemplateName="objectForm.docTemplateName"
                              @submit-success="submitSuccess"
                              @submit-error="submitError"
            ></esTemplateUpload>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import esTemplateUpload from '@/components/w-upload/esNewUpload'
export default {
  name : '',
  components: {
    esTemplateUpload,
  },
  data() {
    return {
      mode : 'add',
      objectForm : {
        id : '',
        docTemplateName : '',
      },
      objectFormRules : {
        docTemplateName: [{ required: true,message: '请输入',	trigger: 'blur',}],
      },
      acceptType : ['doc','docx','pdf'],
    }
  },
  mounted() {},
  computed: {},
  // 进入缓存页面
  activated() {

  },
  watch: {},
  created() {},
  methods: {
    doSave(){
      this.$refs.objectForm.validate(valid => {
        if (valid) {
          //this.$refs.upload()
          this.$refs.uploadTemplate.submit();
        }
      })
    },
    submitSuccess(){
      this.$emit('submit-success')
    },
    submitError(){
      this.$emit('submit-error')
    },
  }
}
</script>
<style lang="less" scoped>
.add-template-form-page {

}
</style>
